import { CheckCircle } from 'lucide-react';
import type { ReactNode } from 'react';

interface BillValidatedCardProps {
  title?: string;
  children: ReactNode;
}

export function BillValidatedCard({ title = 'Verified', children }: BillValidatedCardProps) {
  return (
    <div className="rounded-xl border border-green-200 bg-green-50 p-4">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-green-800">
        <CheckCircle className="h-4 w-4 text-green-600" />
        {title}
      </div>
      <div className="space-y-1 text-sm text-green-900">{children}</div>
    </div>
  );
}
